//token
export const GET_TOKEN = 'GET_TOKEN';
export const ACTIVE_TOKEN = 'ACTIVE_TOKEN';
export const REDIRECT_LOGIN = 'REDIRECT_LOGIN';
export const RESET_TOKEN = 'RESET_TOKEN';
//otros
export const GET_PARAM = 'GET_PARAM';
export const PARAM_ERROR = 'PARAM_ERROR'
export const ADD_RECLAMO = 'ADD_RECLAMO';
export const GET_DATA_USER = 'GET_DATA_USER';
export const GET_COMUNAS = 'GET_COMUNAS';
export const GET_REGIONID = 'GET_REGIONID';
export const SEND_RECLAMO = 'SEND_RECLAMO';
export const RECLAMO_ENVIADO = 'RECLAMO_ENVIADO';
export const DATA_RECLAMO_ENVIADO = 'DATA_RECLAMO_ENVIADO';
export const GET_ARCHIVOS = 'GET_ARCHIVOS';
export const GET_PHONE_NUMBER = 'GET_PHONE_NUMBER';
export const GET_TEMPORALES = 'GET_TEMPORALES';
export const ENVIANDO_DATA = 'ENVIANDO_DATA';
export const PRIMERA_LLAMADA = 'PRIMERA_LLAMADA';
export const RESET_RECLAMO = 'RESET_RECLAMO';
//control de errores
export const EXISTENTE_ERROR = 'EXISTENTE_ERROR';
export const FUERA_PLAZO_ERROR = 'FUERA_PLAZO_ERROR';

